import { generateImagePath } from '../../../../helpers/helpers';
import { commonFieldConfig, commonFieldTypes } from '../inputs/field.config';
import FieldTypeSelector from '../inputs/Index';
export default function HeaderSection({ handleInputChange, investmentData }) {
  const headerSectionFieldsEn = [
    {
      label: 'Investment Title',
      value: investmentData.en.headerSection.investmentTitle,
      section: 'headerSection',
      field: 'investmentTitle',
      config: { ...commonFieldConfig['en'][commonFieldTypes.text] },
    },
    {
      label: 'Location',
      value: investmentData.en.headerSection.location,
      section: 'headerSection',
      field: 'location',
      config: { ...commonFieldConfig['en'][commonFieldTypes.text] },
    },
    {
      label: 'Price',
      value: investmentData.en.headerSection.price,
      section: 'headerSection',
      field: 'price',
      config: { ...commonFieldConfig['en'][commonFieldTypes.text] },
    },
    {
      label: 'City',
      value: investmentData.en.headerSection.city,
      section: 'headerSection',
      field: 'city',
      config: { ...commonFieldConfig['en'][commonFieldTypes.dropdown] },
    },
  ];

  const imageSection = {
    label: 'Image URL',
    value: investmentData.en.headerSection.image,
    section: 'headerSection',
    field: 'image',
    config: { ...commonFieldConfig['en'][commonFieldTypes.image] },
  };
  const headerSectionFieldsAr = [
    {
      label: 'عنوان المشروع',
      value: investmentData.ar.headerSection.investmentTitle,
      section: 'headerSection',
      field: 'investmentTitle',
      config: { ...commonFieldConfig['ar'][commonFieldTypes.text] },
    },
    {
      label: 'الموقع',
      value: investmentData.ar.headerSection.location,
      section: 'headerSection',
      field: 'location',
      config: { ...commonFieldConfig['ar'][commonFieldTypes.text] },
    },
    {
      label: 'السعر',
      value: investmentData.ar.headerSection.price,
      section: 'headerSection',
      field: 'price',
      config: { ...commonFieldConfig['ar'][commonFieldTypes.text] },
    },
  ];

  return (
    <section className="mb-5">
      <h3 className="mb-3">Project Header</h3>
      <div className="d-flex gap-3">
        <img
          src={generateImagePath('header-section.webp')}
          alt=""
          className="mb-3 w-75"
        />
        <img
          className="w-25"
          src={generateImagePath('investmentCard.webp')}
          alt=""
        />
      </div>

      <div className="row">
        {/* English Fields */}
        <div className="col-md-6">
          {headerSectionFieldsEn.map((field, index) => (
            <FieldTypeSelector
              fieldName={field.field}
              key={index}
              label={field.label}
              value={field.value}
              config={field.config}
              onInputChange={(e) =>
                handleInputChange({
                  e,
                  section: field.section,
                  field: field.field,
                  lang: 'en',
                  isSameValue: field.config?.isSameValue, // Now this should work
                })
              }
            />
          ))}
        </div>

        {/* Arabic Fields */}
        <div className="col-md-6" dir="rtl">
          {headerSectionFieldsAr.map((field, index) => (
            <FieldTypeSelector
              fieldName={field.field}
              key={index}
              label={field.label}
              value={field.value}
              config={field.config}
              onInputChange={(e) =>
                handleInputChange({
                  e,
                  section: field.section,
                  field: field.field,
                  lang: 'ar',
                })
              }
            />
          ))}
        </div>
      </div>
      {imageSection && (
        <FieldTypeSelector
          fieldName={imageSection.field}
          label={imageSection.label}
          value={imageSection.value}
          config={imageSection.config}
          onInputChange={(e) =>
            handleInputChange({
              e,
              section: imageSection.section,
              field: imageSection.field,
              lang: 'en',
              isSameValue: imageSection.config?.isSameValue, // Now this should work
            })
          }
        />
      )}
    </section>
  );
}
